import React, { useState, useEffect, useCallback } from 'react';
import { Container, Form, Row, Col, Button } from '@themesberg/react-bootstrap';
import { normalizeDate, validPermission } from '../../utils/functions';
import { useSelector } from "react-redux";
import MultiSelectDropdown from './multiSelectDropdown';

const SearchFormInspect = ({ searching }) => {
  const permissions = useSelector((state) => state.user.permissions)
  const [isSearching, setIsSearching] = useState(false);
  const [infoForm, setInfoForm] = useState({
    placa: '',
    id_client: '',
    client: '',
    state: [],
    init_date: '',
    end_date: '',
  });

  const stateOptions = [
    { value: 'C', label: 'Creado' },
    { value: 'P', label: 'En Proceso' },
    { value: 'A', label: 'Pendiente de Autorizacion' },
    { value: 'AP', label: 'Proceso de Autorizacion' },
    { value: 'T', label: 'Terminado' },
    { value: 'I', label: 'Impreso' },
  ];

  useEffect(() => {
    const currentDate = new Date();
    const defaultDate = normalizeDate(currentDate);
    setInfoForm((prevForm) => ({
      ...prevForm,
      init_date: defaultDate,
      end_date: defaultDate,
    }));
  }, []);

  // eslint-disable-next-line
  useEffect(() => { if (!validPermission(permissions, 'filter')) { searching(infoForm); } }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInfoForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  const handleStateChange = (newValues) => {
    setInfoForm((prevForm) => ({
      ...prevForm,
      state: newValues,
    }));
  };

  const localSearch = useCallback(async () => {
    setIsSearching(true);
    await searching(infoForm);
    setIsSearching(false);
  }, [infoForm, searching]);

  if (!validPermission(permissions, 'filter')) return null

  return (
    <Container className="p-4">
      <Form>
        <Row className="mb-3">
          <Col md={3}>
            <Form.Group>
              <Form.Label>Placa Vehiculo</Form.Label>
              <Form.Control
                name="placa"
                value={infoForm.placa}
                type="text"
                className="fw-bold text-uppercase"
                onChange={handleInputChange}
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label>Cedula Cliente</Form.Label>
              <Form.Control
                name="id_client"
                value={infoForm.id_client}
                type="text"
                onChange={handleInputChange}
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label>Nombre Cliente</Form.Label>
              <Form.Control
                name="client"
                value={infoForm.client}
                type="text"
                onChange={handleInputChange}
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label>Estado</Form.Label>
              <MultiSelectDropdown
                value={infoForm.state}
                onChange={handleStateChange}
                options={stateOptions}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col>
            <Form.Group>
              <Form.Label>Fecha Inicio</Form.Label>
              <Form.Control
                name="init_date"
                value={infoForm.init_date}
                type="date"
                onChange={handleInputChange}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <Form.Label>Fecha Fin</Form.Label>
              <Form.Control
                name="end_date"
                value={infoForm.end_date}
                type="date"
                onChange={handleInputChange}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Button
            onClick={localSearch}
            variant="outline-primary"
            disabled={isSearching}
          >
            {isSearching ? 'Buscando...' : 'Buscar'}
          </Button>
        </Row>
      </Form>
    </Container>
  );
};

export default SearchFormInspect;